export enum ReportConditionRating {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  DIAGNOSED = 'diagnosed'
}

export interface ICountResult {
  count: number;
  total: number;
  percentage: number;
  riskScore: ReportConditionRating;
}

export interface IConditionScores {
  painByCondition: number;
  scores: {
    PD: ICountResult;
    endometriosis: ICountResult;
    PCOS: ICountResult;
    adenomyosis: ICountResult;
    PID: ICountResult;
    fibroids: ICountResult;
  };
  'your-pain': string[];
  'symptoms-and-signs': string[];
}
